import type { Middleware } from '@reduxjs/toolkit';
import { addMessage, removeMessage } from '../slices/feedbackSlice';
import { wsConnected } from '../slices/authSlice';
import { logout } from '../slices/authSlice';
import { MessageSeverity } from '../../types';
import connectionSuccessSound from '../../assets/sounds/connection_success.mp3';
import connectionErrorSound from '../../assets/sounds/connection_error.mp3';

const WS_DISCONNECTED_MSG_ID = 'FEEDBACK@WEBSCOKET_DISCONNECTED_MESSAGE_ID';

/**
 * Middleware that handles:
 * 1. Auto-removing feedback messages after timeout
 * 2. WebSocket connection status messages (watchdog)
 */
export const feedbackMiddleware: Middleware = (storeApi) => (next) => (action) => {
  const result = next(action);
  const { dispatch, getState } = storeApi;

  // Auto-remove messages with timeout
  if (addMessage.match(action)) {
    const msg = action.payload;
    const timeout = msg.timeout ?? 4000;
    if (timeout >= 0 && (msg.autoRemove == null || msg.autoRemove)) {
      setTimeout(() => {
        dispatch(removeMessage(msg.id || ''));
      }, timeout);
    }
  }

  // WebSocket disconnect watchdog
  // Note: We detect disconnect via socket.io events dispatched through socketMiddleware
  // The actual disconnect/reconnect messages are handled in the socket init

  // Cleanup on logout
  if (logout.match(action)) {
    dispatch(removeMessage(WS_DISCONNECTED_MSG_ID));
  }

  return result;
};

// Helper functions for socket middleware to call
export function showDisconnectedMessage(dispatch: any) {
  dispatch(addMessage({
    id: WS_DISCONNECTED_MSG_ID,
    message: 'Izgubili smo vezu sa serverom. Pokušavamo se spojiti ...',
    autoRemove: false,
    severity: MessageSeverity.ERROR,
    sound: connectionErrorSound,
  }));
}

export function showReconnectedMessage(dispatch: any) {
  dispatch(removeMessage(WS_DISCONNECTED_MSG_ID));
  dispatch(addMessage({
    message: 'Ponovno smo se spojili na server :-)',
    severity: MessageSeverity.SUCCESS,
  }));
}
